import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';

const ReferProfileCard = ({ agentDetails }) => {
  return (
    <div className="w-full">
      {/* Agent Logo */}
      <div className="w-24 h-24 rounded-full border border-slate-200 bg-white mx-auto mb-6 flex items-center justify-center overflow-hidden shadow-sm">
        {agentDetails.logo ? (
          <img
            src={agentDetails.logo}
            alt={agentDetails.company_name}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-4xl text-[#067978] font-bold">
            {agentDetails.company_name?.charAt(0).toUpperCase()}
          </span>
        )}
      </div>

      {/* Welcome Tagline */}
      <p className="text-slate-500 text-xs font-normal tracking-wide mb-1.5">
        Need a cool travel experience?
      </p>

      {/* Company Name */}
      <h1 className="text-2xl font-bold text-slate-800 mb-3 tracking-tight leading-tight">
        {agentDetails.company_name}
      </h1>

      {/* Referral Welcome Subtext */}
      <p className="text-slate-600 text-[13px] leading-relaxed mb-6 font-medium px-2">
        Highly recommended for planning your next adventure. Get in touch below to design your perfect getaway!
      </p>

      {/* Address/City */}
      {(agentDetails.address || agentDetails.city) && (
        <div className="text-slate-500 text-xs mb-8 flex items-center justify-center gap-1.5 font-medium">
          <MapPin size={12} className="text-[#067978]" />
          <span>
            {[agentDetails.address, agentDetails.city].filter(Boolean).join(', ')}
          </span>
        </div>
      )}

      <div className="w-full border-t border-slate-100 my-6" />

      {/* Action & Contact Detail Cards */}
      <div className="w-full space-y-4">
        {/* Phone Details Card */}
        <div className="bg-slate-50/80 border border-slate-100/70 rounded-2xl p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-center sm:text-left w-full shadow-sm">
          <div className="min-w-0">
            <p className="text-[11px] font-semibold text-slate-400 mb-0.5">Phone Number</p>
            <p className="text-slate-800 text-base font-bold tracking-tight">
              {agentDetails.phone_number}
            </p>
          </div>
          <div className="flex gap-2 shrink-0 justify-center">
            <a
              href={`tel:${agentDetails.phone_number}`}
              className="bg-white hover:bg-slate-50 text-slate-700 font-bold py-2.5 px-3.5 rounded-xl border border-slate-200 transition-all flex items-center gap-1.5 text-xs hover:-translate-y-0.5 shadow-sm"
            >
              <Phone size={13} className="text-[#067978]" /> Call
            </a>
            <a
              href={`https://wa.me/91${agentDetails.phone_number.replace(/\D/g, '')}?text=Hi,%20I'd%20like%20to%20enquire%20about%20a%20trip!`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white hover:bg-slate-50 text-slate-700 font-bold py-2.5 px-3.5 rounded-xl border border-slate-200 transition-all flex items-center gap-1.5 text-xs hover:-translate-y-0.5 shadow-sm"
            >
              <MessageCircle size={13} className="text-[#067978]" /> WhatsApp
            </a>
          </div>
        </div>

        {/* Email Details Card */}
        <div className="bg-slate-50/80 border border-slate-100/70 rounded-2xl p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-center sm:text-left w-full shadow-sm">
          <div className="min-w-0 flex-1">
            <p className="text-[11px] font-semibold text-slate-400 mb-0.5">Email Address</p>
            <p
              className="text-slate-800 text-[14px] font-bold truncate pr-2 w-full"
              title={agentDetails.email}
            >
              {agentDetails.email}
            </p>
          </div>
          <a
            href={`mailto:${agentDetails.email}`}
            className="bg-[#067978] hover:bg-[#05605f] text-white font-bold py-2.5 px-4 rounded-xl border border-[#067978]/50 transition-all flex items-center gap-1.5 text-xs shrink-0 shadow-[0_4px_12px_rgba(6,121,120,0.15)] hover:-translate-y-0.5"
          >
            <Mail size={13} /> Email
          </a>
        </div>
      </div>
    </div>
  );
};

export default ReferProfileCard;
